import { GetConversationHistoryResponses } from '@botpress/hitl-client'

// These statuses are only preliminary, this can be changed
// "pending" | "assigned" | "timed_out" | "cancelled" | "solved" | "unknown"
export const conversationStatuses = ['pending', 'assigned', 'timed_out', 'cancelled', 'solved', 'unknown'] as const
export type ConversationStatus = (typeof conversationStatuses)[number]

export const isConversationStatus = (value: any): value is ConversationStatus => conversationStatuses.includes(value)

export type HistoricMessage = GetConversationHistoryResponses['200']['hitlMessageHistory'][number]
